import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';
import * as async from 'async';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@devinforius/i-essentials';
import { ConnectorsService } from 'src/app/shared/services/connectors.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { Cols } from 'src/app/shared/models/cols';
import { ExchangeMailList } from 'src/app/shared/models/iCourrier/email/exchange';
import { Exchange, ExchangeEmail, ExchangeMailListColumn } from 'src/app/shared/models/exchange/exchange';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-courrier-exchange',
  templateUrl: './courrier-exchange.component.html',
  styleUrls: ['./courrier-exchange.component.scss'],
})
export class CourrierExchangeComponent implements OnInit {
  public boxType = '';
  public boites: Array<{ label: string; value: string; click: (email: string, boxType: string) => void }> = [
    {
      label: 'Eléments reçus',
      value: 'inbox',
      click: (email, boxType) => {
        this.emailToConnect = email;
        this.boxType = boxType;
        let arrayToken = [];
        arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));

        let tokenToReceive = [];
        if (arrayToken?.length > 0) {
          tokenToReceive = arrayToken.filter((x) => x.email === this.emailToConnect);
        }
        if (tokenToReceive.length > 0) {
          this.getInbox(tokenToReceive[0].token);
        } else {
          if (this.boxType === 'global') {
            let arrayToken = [];
            arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
            if (this.exchangeParams.globalMailboxCredentials) {
              if (arrayToken && arrayToken.length > 0) {
                arrayToken.push({ email: this.emailToConnect, token: this.exchangeParams.globalMailboxCredentials });
                sessionStorage.setItem('access_token_exchange', JSON.stringify(arrayToken));
                this.getInbox(this.exchangeParams.globalMailboxCredentials);
              } else {
                const temp = [];
                temp.push({ email: this.emailToConnect, token: this.exchangeParams.globalMailboxCredentials });
                sessionStorage.setItem('access_token_exchange', JSON.stringify(temp));
                this.getInbox(this.exchangeParams.globalMailboxCredentials);
              }
            }
          } else {
            this.showLoginModal = true;
            this.formLogin.reset();
            if (this.boxType === 'shared') {
              this.formLogin.patchValue({
                login: this.emailToConnect,
              });
            }
          }
        }
      },
    },
    {
      label: 'Eléments envoyés',
      value: 'outbox',
      click: (email, boxType) => {
        this.emailToConnect = email;
        this.boxType = boxType;
        let arrayToken = [];
        arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
        let tokenToReceive = [];

        if (arrayToken && arrayToken.length > 0) {
          tokenToReceive = arrayToken.filter((x) => x.email === this.emailToConnect);
        }
        if (tokenToReceive.length > 0) {
          this.getOutBox(tokenToReceive[0].token);
        } else {
          if (this.boxType === 'global') {
            let arrayToken = [];
            arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
            if (arrayToken && arrayToken.length > 0) {
              arrayToken.push({ email: this.emailToConnect, token: this.exchangeParams.globalMailboxCredentials });
              sessionStorage.setItem('access_token_exchange', JSON.stringify(arrayToken));
              this.getOutBox(this.exchangeParams.globalMailboxCredentials);
            } else {
              const temp = [];
              temp.push({ email: this.emailToConnect, token: this.exchangeParams.globalMailboxCredentials });
              sessionStorage.setItem('access_token_exchange', JSON.stringify(temp));
              this.getOutBox(this.exchangeParams.globalMailboxCredentials);
            }
          } else {
            this.showLoginModal = true;
            this.formLogin.reset();
            if (this.boxType === 'shared') {
              this.formLogin.patchValue({
                login: this.emailToConnect,
              });
            }
          }
        }
      },
    },
  ];
  public exchangeParams: Exchange = null;
  public showLoginModal = false;
  public formLogin = new UntypedFormGroup({
    login: new FormControl<string>(null),
    password: new FormControl<string>(null),
  });
  public whichBox = '';
  public columns: Array<Cols> = [
    {
      field: 'exchangeMailChargeLabel',
      header: 'Traité',
      format: (_value, item) => {
        if (item.exchangeMailChargeId) {
          return `✅`;
        } else {
          return `❌`;
        }
      },
    },
    {
      field: 'dateMail',
      header: 'Date',
      format: (value) => {
        if (value) {
          return moment(value).format('DD/MM/YYYY à HH:mm');
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        const val1 = moment(a, 'DD/MM/YYYY à HH:mm').isValid() ? moment(a, 'DD/MM/YYYY à HH:mm').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY à HH:mm').isValid() ? moment(b, 'DD/MM/YYYY à HH:mm').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'subject',
      header: 'Sujet',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'expediteur',
      header: 'Expediteur',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'expediteurEmail',
      header: 'Email expéditeur',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'a',
      header: 'Actions',
      format: () => {
        return `<div class="btn btn-primary d-block w-100">Créer courrier</div>`;
      },
      click: (row: ExchangeMailListColumn) => {
        this.checkIfAlreadyCreated(row);
      },
    },
  ];
  public items: ExchangeMailList[] = [];
  public showOpenEmail = false;
  public emailObject: ExchangeEmail;
  public emailToConnect = '';
  public openShared = false;
  public sharedEmailToAdd = '';
  public encodage: Array<{ label: string; value: string }> = [
    {
      label: 'UTF-7',
      value: 'UTF-7',
    },
    {
      label: 'UTF-8',
      value: 'UTF-8',
    },
  ];
  public encoding = 'UTF-8';
  public mailId: number;
  constructor(
    public dataService: DataService,
    public toastr: ToastrService,
    public dialogService: DialogService,
    public router: Router,
    public contactService: ContactsService,
    public spinner: NgxSpinnerService,
    public confirmService: ConfirmationService,
    private titleService: Title,
    private translater: TranslateService,
    private connectorsService: ConnectorsService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.translater.translate('tabsTitle.emails'));

    this.getExchangeParams();
  }

  getExchangeParams(): void {
    this.connectorsService.getExchangesParams().subscribe({
      next: (res) => {
        this.exchangeParams = new Exchange(res);
      },
    });
  }

  getInbox(autorization): void {
    this.spinner.show();
    this.connectorsService.getBoxIn(autorization).subscribe({
      next: (res) => {
        this.items = res.map((item) => new ExchangeMailList(item, 'E'));
        this.spinner.hide();
      },
    });
  }

  getOutBox(autorization): void {
    this.spinner.show();
    this.connectorsService.getBoxOut(autorization).subscribe({
      next: (res) => {
        this.items = res.map((item) => new ExchangeMailList(item, 'S'));
        this.spinner.hide();
      },
    });
  }

  login(): void {
    const authorization = btoa(this.formLogin.value.login + ':' + this.formLogin.value.password);
    this.connectorsService.postEncryptExchange(authorization).subscribe({
      next: (res) => {
        this.toastr.success('Connexion effectuée avec succès');
        if (!sessionStorage.getItem('access_token_exchange')) {
          const temp = [];
          temp.push({ email: this.emailToConnect, token: res });
          sessionStorage.setItem('access_token_exchange', JSON.stringify(temp));
        } else {
          const temp = JSON.parse(sessionStorage.getItem('access_token_exchange'));
          temp.push({ email: this.emailToConnect, token: res });
          sessionStorage.setItem('access_token_exchange', JSON.stringify(temp));
        }
        this.showLoginModal = false;
        switch (this.whichBox) {
          case 'inbox':
            this.getInbox(res);
            break;
          case 'outbox':
            this.getOutBox(res);
            break;
          default:
            this.getInbox(res);
            break;
        }
      },
    });
  }

  deleteSelection(items): void {
    let count = 0;
    let tokenToReceive = [];
    let arrayToken = [];
    arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
    tokenToReceive = arrayToken.filter((x) => x.email === this.emailToConnect);

    if (tokenToReceive.length > 0) {
      if (items?.length > 0) {
        items.map((item) => {
          this.connectorsService.deleteMailExchange(tokenToReceive[0].token, { mailUniqueId: item.mailId }).subscribe({
            next: () => {
              this.toastr.success('Le courrier a bien été supprimé');
              count = count + 1;
              if (count === items.length) {
                this.getInbox(tokenToReceive[0].token);
                this.getOutBox(tokenToReceive[0].token);
              }
            },
          });
        });
      }
    }
  }

  showDialog(event): void {
    this.showOpenEmail = true;
    this.spinner.show();
    let tokenToReceive = [];
    let arrayToken = [];
    this.mailId = event.mailId;
    arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
    tokenToReceive = arrayToken.filter((x) => x.email === this.emailToConnect);
    if (tokenToReceive.length > 0) {
      this.connectorsService.postEmailByIDFromExchange(tokenToReceive[0].token, { mailUniqueId: event.mailId }, this.encoding).subscribe({
        next: (res) => {
          this.emailObject = new ExchangeEmail(res);
          this.spinner.hide();
        },
      });
    }
  }

  checkIfAlreadyCreated(item: ExchangeMailListColumn): void {
    let tokenToReceive = [];
    let arrayToken = [];

    arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
    tokenToReceive = arrayToken.filter((x) => x.email === this.emailToConnect);

    if (tokenToReceive.length > 0) {
      if (item.exchangeMailChargeLabel === '✅') {
        this.contactService.fetchContact(item.exchangeMailCharge.contactId, 'iCourrier').subscribe({
          next: (res) => {
            this.confirmService.confirm({
              header: 'Souhaitez-vous créer ce courrier?',
              message:
                'Ce courrier à déjà été pris en charge le ' +
                moment(item.exchangeMailCharge.datePriseEnMain).format('DD/MM/YYYY à HH:mm') +
                ' par ' +
                res.nom,
              key: 'shared',
              accept: () => {
                this.createOutgoingMail(item, tokenToReceive);
              },
            });
          },
        });
      } else {
        this.createOutgoingMail(item, tokenToReceive);
      }
    }
  }

  private createOutgoingMail(item: ExchangeMailListColumn, tokenToReceive) {
    forkJoin({
      getEmailId: this.connectorsService.getEmailByIDFromExchange(tokenToReceive[0].token, { mailUniqueId: item.mailId }).pipe(
        catchError(() => {
          this.toastr.error("Une erreur est survenue lors de la recherche de l'email");
          return of(null);
        })
      ),
      postEmail: this.connectorsService
        .postEmailByIDFromExchange(tokenToReceive[0].token, { mailUniqueId: item.mailId, markAsUsed: true }, this.encoding)
        .pipe(
          catchError(() => {
            this.toastr.error("Une erreur est survenue lors de la recherche de l'email (post)");
            return of(null);
          })
        ),
    }).subscribe((value) => {
      const file = new File([value.getEmailId], item.subject + '.eml');
      this.dataService.setCurrentAttachement(file);
      this.emailObject = new ExchangeEmail(value.postEmail);

      item.emailObject = this.emailObject;
      item.dateDocument = item.date;
      item.token = tokenToReceive[0].token;
      this.dataService.setCurrentMail(item);
      this.router.navigate(['/private/ic/new-mail', { mode: 'fileViewer' }]);
    });
  }

  deleteShared(arrayShared, shared): void {
    if (arrayShared.length > 0) {
      this.confirmService.confirm({
        message: 'Voulez-vous vraiment supprimer cette boite partagée?',
        key: 'shared',
        accept: () => {
          let boxArrayToSend = [];
          boxArrayToSend = arrayShared.filter((x) => x !== shared);
          this.connectorsService.putBoitePartagee({ boitesPartagees: boxArrayToSend }).subscribe({
            next: () => {
              this.toastr.success('Boite partagée supprimée avec succès');
              this.getExchangeParams();
            },
          });
        },
      });
    }
  }

  addShared(): void {
    let boxArrayToSend = [];
    boxArrayToSend = this.exchangeParams.sharedMailboxes;
    boxArrayToSend.push(this.sharedEmailToAdd);

    this.connectorsService.putBoitePartagee({ boitesPartagees: boxArrayToSend }).subscribe({
      next: () => {
        this.toastr.success('Boite partagée ajoutée avec succès');
        this.getExchangeParams();
        this.openShared = false;
      },
    });
  }

  changeEncodage(): void {
    let tokenToReceive = [];
    let arrayToken = [];
    arrayToken = JSON.parse(sessionStorage.getItem('access_token_exchange'));
    tokenToReceive = arrayToken.filter((x) => x.email === this.emailToConnect);
    this.connectorsService.postEmailByIDFromExchange(tokenToReceive[0].token, { mailUniqueId: this.mailId?.toString() }, this.encoding).subscribe({
      next: (res) => {
        this.emailObject = new ExchangeEmail(res);
      },
    });
  }
}
